import { useEffect, useRef } from 'react'
import * as echarts from 'echarts/core'
import type { EChartsCoreOption } from 'echarts/core'

const instances = new Set<echarts.ECharts>()

export function resizeAllCharts() {
  instances.forEach((chart) => chart.resize())
}

export function useECharts(option: EChartsCoreOption) {
  const ref = useRef<HTMLDivElement>(null)
  const chart = useRef<echarts.ECharts | null>(null)

  useEffect(() => {
    if (!ref.current) return
    chart.current = echarts.init(ref.current)
    instances.add(chart.current)

    const ro = new ResizeObserver(() => chart.current?.resize())
    ro.observe(ref.current)

    return () => {
      if (chart.current) instances.delete(chart.current)
      chart.current?.dispose()
      ro.disconnect()
    }
  }, [])

  useEffect(() => {
    chart.current?.setOption(option)
  }, [option])

  return ref
}
